"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = resourcePrefetch;

var _joinURL = _interopRequireDefault(require("../common/joinURL.js"));

var _resourceHint = _interopRequireDefault(require("../common/resourceHint.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function resourcePrefetch(_ref, siteModel, publicModel, pageInfo, wixBiSession, isServerSide, mobileView, experiment, requirejs) {
  var XMLHttpRequest = _ref.XMLHttpRequest,
      document = _ref.document;

  if (!publicModel) {
    return {
      contentCache: function contentCache() {},
      prefetchResources: function prefetchResources() {},
      setContext: function setContext() {}
    };
  }

  var cache = {};
  var pending = {};
  var context = {
    shouldDelay: function shouldDelay() {}
  }; // No point prefetching if we're already at the fetching stage

  var inPrefetchStage = function inPrefetchStage() {
    return wixBiSession.et < 6;
  };

  function ajaxSuccess(options, response, xhr) {
    options.success.call(options.context || options, response, 'success', xhr);
  }

  function ajaxError(options, xhr) {
    options.error.call(options.context || options, xhr, xhr.status ? 'error' : 'abort', xhr.statusText);
  }

  function _prefetch(url) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        parse = _ref2.parse,
        accept = _ref2.accept;

    var xhr = new XMLHttpRequest();

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        var response = parse ? parse(xhr.response) : xhr.response;

        if (response) {
          cache[url] = {
            response: response,
            xhr: xhr
          };
          pending[url].filter(function (_ref3) {
            var success = _ref3.success;
            return success;
          }).forEach(function (op) {
            ajaxSuccess(op, response, xhr);
          });
          return;
        }
      }

      this.onerror();
    };

    xhr.onerror = function () {
      cache[url] = {
        response: null,
        xhr: xhr
      };
      pending[url].filter(function (_ref4) {
        var error = _ref4.error;
        return error;
      }).forEach(function (op) {
        ajaxError(op, xhr);
      });
    };

    xhr.onloadend = function () {
      delete pending[url];
    };

    xhr.open('GET', url, true);

    if (accept) {
      xhr.setRequestHeader('Accept', accept);
    }

    xhr.send();
  }

  function respond(options, _ref5) {
    var response = _ref5.response,
        xhr = _ref5.xhr;

    if (response) {
      if (options.success) {
        ajaxSuccess(options, response, xhr);
      }
    } else if (options.error) {
      ajaxError(options, xhr);
    }
  }

  function prefetch(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (url) {
      var cached = cache[url];

      if (cached) {
        respond(options, cached);
      } else {
        var p = pending[url];

        if (!p) {
          pending[url] = p = [];

          _prefetch(url, options);
        }

        if (options.success || options.error) {
          p.push(options);
        }
      }
    }
  }

  function prefetchJSON(url) {
    prefetch(url, {
      accept: 'application/json',
      parse: function parse(response) {
        try {
          var json = JSON.parse(response);

          if (inPrefetchStage()) {
            prefetchComps(json);
            prefetchSvg(json.structure, response);
          }

          return json;
        } catch (e) {
          return null;
        }
      }
    });
  }

  function getChildren(comp, isMobile) {
    if (isMobile) {
      return comp.mobileComponents || comp.components || [];
    }

    return comp.children || comp.components || [];
  }

  function getComponentsToPrefetch(_ref6, _siteModel, _mobileView) {
    var structure = _ref6.structure;
    var componentTypes = [];

    function traverse(comp) {
      var componentType = comp.componentType;

      if (componentType) {
        componentTypes.push(componentType);
      }

      var subComps = getChildren(comp, _mobileView);
      subComps.forEach(traverse);
    }

    if (structure) {
      traverse(structure);
    }

    return componentTypes.length ? componentTypes : null;
  }

  function prefetchComps(json) {
    requirejs(['core'], function (core) {
      if (inPrefetchStage()) {
        var viewerCompsService = core.viewerCompsService;
        var componentTypes = getComponentsToPrefetch(json, siteModel, mobileView);

        if (componentTypes) {
          if (document.getElementById('WIX_ADS')) {
            componentTypes.push('wysiwyg.viewer.components.WixFreemiumBanner');
          }

          viewerCompsService.prefetchComponents(componentTypes, siteModel);
        }
      }
    });
  }

  function shapeSkinNameToUrl(shapeSkinName) {
    function getSvgUri(version, svgHash, shapeName) {
      return svgHash + (version === 1 ? '_svgshape.v1.' + shapeName : '') + '.svg'; //eslint-disable-line prefer-template
    }

    var mediaRootUrl = siteModel.serviceTopology.mediaRootUrl;
    var partsArr = shapeSkinName.replace(/^.*\//, '').split('.');
    var version = partsArr[1] === 'v1' ? 1 : 2;
    var svgHash = partsArr[2].replace(/svg_/i, '');
    var svgName = partsArr[3];
    var svgUri = getSvgUri(version, svgHash, svgName);
    return (0, _joinURL["default"])(mediaRootUrl, 'shapes', svgUri);
  }

  var svgMap = {
    'skins.viewer.svgshape.SvgShapeDefaultSki': true
  };

  function prefetchSvg(structure, response) {
    if (structure && response.indexOf('"svg') !== -1) {
      var svgs = JSON.stringify(structure).match(/"skin"\s*:\s*"svg[^"]+"/g);

      if (svgs) {
        svgs.map(function (m) {
          m = m.match(/svg[^"]+/);
          return m && m[0];
        }).filter(function (svg) {
          if (!svg || svgMap[svg]) {
            return false;
          }

          svgMap[svg] = true;
          return true;
        }).map(shapeSkinNameToUrl).forEach(function (url) {
          prefetch(url);
        });
      }
    }
  }

  function getFirstUrl(pageJsonFileName) {
    if (pageJsonFileName) {
      var topology = siteModel.rendererModel.pageList.topology[0];
      return topology.baseUrl + topology.parts.replace('{filename}', pageJsonFileName);
    }
  }

  function getMasterPageFirstURL() {
    var _ref7 = publicModel.pageList || {},
        masterPageJsonFileName = _ref7.masterPageJsonFileName,
        masterPage = _ref7.masterPage;

    return getFirstUrl(masterPageJsonFileName) || masterPage && masterPage[0];
  }

  function getPageFirstURL() {
    return getFirstUrl(pageInfo.pageJsonFileName) || pageInfo.urls[0];
  }

  function prefetchTranslations(langs) {
    // There is a bug in IE11 that fail to redirect (status 307) here for cross origin ajax requests WEED-10793
    // Converting http to https will prevent this redirect temporarily until all Parastorage urls in
    // serviceTopology.scriptsLocationMap will be https HTMLSRVR-2321
    var santaLangsUrl = siteModel.serviceTopology.scriptsLocationMap['santa-langs'].replace(/https?/, 'https');
    var urls = [].concat(langs).map(function (l) {
      return "".concat(santaLangsUrl, "/resources/santa-viewer/bundles/_generated/santa_viewer_").concat(l, ".json");
    });
    urls.forEach(prefetchJSON);
  }

  var cbs = [];

  function async(cb) {
    function delay() {
      var top = cbs.shift();

      if (top) {
        top();

        if (cbs.length > 0) {
          setTimeout(delay, 10);
        }
      }
    }

    if (cbs.push(cb) === 1) {
      if (context.shouldDelay()) {
        setTimeout(delay, 10);
      } else {
        setTimeout(function () {
          var fs = cbs;
          cbs = [];
          fs.forEach(function (f) {
            f();
          });
        }, 0);
      }
    }
  }

  return {
    preloadScripts: function preloadScripts(scripts) {
      var SCRIPTS = {
        asType: 'script'
      };
      scripts.map(function (script) {
        return "".concat(requirejs.toUrl(script), ".js");
      }).forEach(function (url) {
        (0, _resourceHint["default"])(document, 'preload', url, SCRIPTS);
      });
    },
    preconnectAssetsServer: function preconnectAssetsServer() {
      (0, _resourceHint["default"])(document, 'preconnect', siteModel.serviceTopology.siteAssetsServerUrl, {
        crossorigin: true
      });
    },
    contentCache: function contentCache(options) {
      var url = options.url;
      var cached = cache[url];

      if (cached) {
        async(function () {
          return respond(options, cached);
        });
      } else if (pending[url]) {
        pending[url].push(options);
      } else {
        return false;
      }

      return true;
    },
    prefetchResources: function prefetchResources(_ref8) {
      var fullPagesData = _ref8.fullPagesData,
          fixedPagesUrls = _ref8.fixedPagesUrls;

      if (fullPagesData) {
        var pages = Object.values(fullPagesData);
        pages.forEach(prefetchComps);
      } else {
        var keys = fixedPagesUrls && Object.keys(fixedPagesUrls);

        if (keys && keys.length) {
          keys.forEach(function (pageId) {
            prefetchJSON(fixedPagesUrls[pageId], pageId);
          });
        } else {
          prefetchJSON(getMasterPageFirstURL(), 'masterPage');

          if (pageInfo) {
            prefetchJSON(getPageFirstURL(), pageInfo.pageId);
          }
        }
      }

      prefetchTranslations('en');
    },
    setContext: function setContext(update) {
      Object.keys(update).forEach(function (key) {
        context[key] = update[key];
      }); // Object.assign(context, update)
    }
  };
}
//# sourceMappingURL=resourcePrefetch.js.map